// @ts-nocheck
import * as Types from "../../../../types/types";

import { gql } from "@apollo/client";
import * as Apollo from "@apollo/client";
const defaultOptions = {} as const;
export type DeleteWorkbookVariantMutationVariables = Types.Exact<{
  variantId: Types.Scalars["ID"]["input"];
}>;

export type DeleteWorkbookVariantMutation = {
  __typename?: "Mutation";
  deleteWorkbookVariant?: {
    __typename?: "DeleteWorkbookVariantPayload";
    workbookId: string;
  } | null;
};

export const DeleteWorkbookVariantDocument = gql`
  mutation DeleteWorkbookVariant($variantId: ID!) {
    deleteWorkbookVariant(variantId: $variantId) {
      workbookId
    }
  }
`;
export type DeleteWorkbookVariantMutationFn = Apollo.MutationFunction<
  DeleteWorkbookVariantMutation,
  DeleteWorkbookVariantMutationVariables
>;

/**
 * __useDeleteWorkbookVariantMutation__
 *
 * To run a mutation, you first call `useDeleteWorkbookVariantMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDeleteWorkbookVariantMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [deleteWorkbookVariantMutation, { data, loading, error }] = useDeleteWorkbookVariantMutation({
 *   variables: {
 *      variantId: // value for 'variantId'
 *   },
 * });
 */
export function useDeleteWorkbookVariantMutation(
  baseOptions?: Apollo.MutationHookOptions<
    DeleteWorkbookVariantMutation,
    DeleteWorkbookVariantMutationVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useMutation<
    DeleteWorkbookVariantMutation,
    DeleteWorkbookVariantMutationVariables
  >(DeleteWorkbookVariantDocument, options);
}
export type DeleteWorkbookVariantMutationHookResult = ReturnType<
  typeof useDeleteWorkbookVariantMutation
>;
export type DeleteWorkbookVariantMutationResult =
  Apollo.MutationResult<DeleteWorkbookVariantMutation>;
export type DeleteWorkbookVariantMutationOptions = Apollo.BaseMutationOptions<
  DeleteWorkbookVariantMutation,
  DeleteWorkbookVariantMutationVariables
>;
